import React from "react";

import user_progress_report from "./user_progress_report.png";

const ReportsProgress = () => (
  <div id="reports_progress" className="section">
    <h2>4.2 User Progress Report</h2>
    <p>
      This report gives a breakdown of how the users have progressed within the courses. It shows
      time taken, status and scores for each course.
    </p>
    <img src={user_progress_report} alt="User Progress" className="center" />
  </div>
);

export default ReportsProgress;
